export const SwiperArrows = ({ prefix = "rcmd" }: { prefix?: string }) => {
  return (
    <>
      <div
        className={"swiper-button-prev " + prefix}
        id={prefix + "-banner-prev"}
      >
        <img src="../../../assets/icons/swiper_prev_arrow.svg" alt="" />
      </div>
      <div
        className={"swiper-button-next " + prefix}
        id={prefix + "-banner-next"}
      >
        <img src="../../../assets/icons/swiper_next_arrow.svg" alt="" />
      </div>
      <div className="swiper-pagination items-center"></div>
    </>
  );
};
